// import firebase from 'firebase/app';
// import 'firebase/database';
// import 'firebase/auth';
// import 'firebase/storage';
import Client from 'shopify-buy';

// const config = {
//     apiKey: 'AIzaSyDYPVC8bVAjxrHYjy34LdG7lFh5ffvCpVw',
//     authDomain: 'adoratorio-studio.firebaseapp.com',
//     databaseURL: 'https://adoratorio-studio.firebaseio.com',
//     storageBucket: 'adoratorio-studio.appspot.com',
//     messagingSenderId: '657583624170',
//     projectId: 'adoratorio-studio',
// };

// const firebaseApp = firebase.initializeApp(config);
// const api = firebaseApp.database().ref();
// const storageRef = firebase.storage().ref();

const shopify = Client.buildClient({
  domain: 'getwearable.myshopify.com',
  storefrontAccessToken: 'bdb45aada35aa2e8a356977b50ff104a',
});

export { shopify };



// WEBPACK FOOTER //
// ./src/store/create-api.js